export const common = {
  getMore: 'Get more',
  account: 'My account',
  error: 'Something went wrong. Please try again later.',
  menu: {
    security: 'Password & security',
    promoCode: 'Use Promo code',
    logout: 'Log out',
  },
  initializer: {
    init: 'Initializing',
  },
  logoutConfirm: {
    title: 'want to log out?',
    description: 'We need your confirmation.',
    apply: 'Confirm',
    reject: 'Cancel',
  },
  promoCodeModal: {
    title: 'Have a <b>promo code?</b>',
    description: 'Apply promo code to get some b-coins',
    code: {
      placeholder: 'Promo code',
    },
    submit: 'Apply',
    activationSuccess: 'You`ve been credited with {{coins}} b-coins',
  },
  cookies: {
    title: 'Cookie Settings',
    text: 'We use cookies for essential website functions and to better understand how you use our site, so we can create the best possible experience for you. <1>Privacy Policy</1>',
    accept: 'Got it',
    acceptMobile: 'Allow all cookies',
  },
  missingTranslation: 'translation not found',
  saveProfileError: 'Unable to save profile',
  fieldRequired: 'Field is required',
};
